import React, { useEffect } from "react";
import { getFormattedDate } from "../../../util/dates";
import Mark from "../../../assets/mark.png";
import PrincipalSign from "../../../assets/guillermo-sign.png";

import "./ConsentmentTemplate.css";

function ConsentmentTemplate({ ciData }) {
  function CreateCheckedTerm({ text }) {
    return (
      <div style={{ display: "flex", flexDirection: "row", width: "86%" }}>
        <div style={{ marginRight: 16 }}>
          <img style={{ maxWidth: 30 }} src={Mark} alt="checked" />
        </div>
        <p className="rtPar">{text}</p>
      </div>
    );
  }

  function CreateParticipant({ data, desc, isSign = false }) {
    return (
      <div style={{ width: "30%" }}>
        <div
          style={{
            borderBottomWidth: 2,
            borderBottomStyle: "solid",
            marginBottom: 5,
          }}
        >
          <p className="rtPar" style={{ textAlign: "center" }}>
            {data}
          </p>
        </div>
        <p className="rtPar" style={{ textAlign: "center" }}>
          {desc}
        </p>
      </div>
    );
  }

  useEffect(() => { }, [ciData]);
  return (
    <div className="rtDocument">
      <div className="rtPage">
        <div className="rtContainer">
          <p className="rtMainTitle" style={{ textAlign: "center" }}>
            CARTA DE CONSENTIMIENTO INFORMADO
          </p>
          <p className="rtPar">
            El presente consentimiento informado cumple con los lineamientos establecidos en el Reglamento de la Ley General de Salud en Materia de investigación para la Salud, la Declaración de Helsinki y las Buenas Prácticas Clínicas emitidas por la Comisión Nacional de Bioética.
          </p>
          <p className="rtPar">
            Para decidir si participa o no en este Programa de Experiencia Temprana para el Suplemento Alimenticio a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina, usted debe de tener el conocimiento suficiente acerca de los riesgos y beneficios que esto implica, con el fin de tomar una decisión acertada. Este documento le dará información detallada acerca del programa, la cual podrá comentar con su médico tratante o con algún miembro del equipo de investigadores. Al terminar de leer este documento se le pedirá que forme parte del proyecto y de ser así, bajo ninguna presión o intimidación, se le invitará a firmar este consentimiento informado.
          </p>
          <p className="rtTitle">
            Invitación a participar y descripción del proyecto.
          </p>
          <p className="rtPar">
            Estimado Sr(a).{" "}
            <span style={{ textDecoration: "underline" }}>
              {ciData.patientCiName}
            </span>
          </p>
          <p className="rtPar">
            Por medio de la presente nos dirigimos a usted para saludarle y hacerle una cordial invitación a participar en el “Programa de Experiencia Temprana para el Suplemento Alimenticio a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina”.
          </p>
          <p className="rtPar">
            El programa tiene como objetivos, evaluar cambios en signos y síntomas clínicos, registro de necesidad de AINEs, tolerabilidad y aceptabilidad de pacientes y opinión de médicos, en la práctica clínica habitual.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Procedimiento del programa
          </p>
          <p className="rtPar">
            1.	Los pacientes asistirán a 3 visitas: una inicial (día 0), una intermedia (día 30) y una final (día 90), durante el desarrollo de este PET.
          </p>
          <p className="rtPar">
            2.	Durante la visita inicial el médico dará de alta a cada paciente en la App o Sitio web.
          </p>
          <p className="rtPar">
            3.	Los pacientes, a través del médico, deberán responder un cuestionario durante cada visita.
          </p>
          <p className="rtPar">
            4.	Los cuestionarios están enfocados en evaluar lo descrito en los objetivos antes mencionados.
          </p>
          <p className="rtPar">
            5.	En caso de presentar algún efecto secundario, proporcionará la información adicional que el médico le solicite.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Riesgos e inconvenientes
          </p>
          <p className="rtPar" style={{ marginBottom: 0 }}>
            No se conocen riesgos e inconvenientes con el uso de este Suplemento alimenticio en la población de 40 a 80 años.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Privacidad
          </p>
          <p className="rtPar">
            Los datos acerca de su identidad y su información médica NO serán revelados en ningún momento como lo estipula la ley, por tanto, en la recolección de datos clínicos, usted no enfrenta riesgos mayores a los relativos a la protección de la confidencialidad la cual será protegida mediante la codificación de su información.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Beneficios potenciales
          </p>
          <p className="rtPar">
            El Suplemento alimenticio complementa la dieta a base de SPM´s, Omega 3, Colágeno nativo tipo II sin desnaturalizar (UC-II) y Astaxantina. Los cuales pueden ayudar en la mejora de la osteoartritis de rodilla grado 1 y 2, ya sea unilateral o bilateral.
          </p>
        </div>
      </div>
      <div className="rtPage">
        <div className="rtContainer">
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Participación y retiro del programa
          </p>
          <p className="rtPar">
            Su participación es VOLUNTARIA. Si usted decide no participar, no se afectará su relación con su médico o con su derecho a recibir atención médica o cualquier otro servicio al que tenga derecho. Si decide participar, tiene la libertad de retirar su consentimiento e interrumpir su participación en cualquier momento sin perjudicar su atención médica. Se le informará a tiempo si se obtiene nueva información que pueda afectar su decisión para continuar en el programa. El profesional de la salud puede excluirlo del programa si usted no tiene el apego suficiente a la administración. También podrá ser retirado del programa en caso de que su médico lo considere necesario para su beneficio.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Confidencialidad y manejo de su información
          </p>
          <p className="rtPar">
            Su nombre no será usado en ninguno de los programas. Su confidencialidad será protegida como lo marca la ley. Los representantes de ventas de Exeltis Pharma México podrán tener acceso a la información de los participantes. Si usted decide retirarse del programa, podrá solicitar el retiro y destrucción de su información. Todas las hojas de recolección de datos serán guardadas con las mismas medidas de confidencialidad, y solo los coordinadores titulares tendrán acceso a los datos que tienen su nombre. En el futuro, si identificamos información que consideremos importante para su salud, consultaremos con alguna Comisión de ética que supervise el programa para decidir la mejor forma de darle esta información a usted y a su médico. Además, le solicitamos que nos autorice contactarlo, en caso de ser necesario, para solicitarle información adicional que podría ser relevante para el desarrollo de este proyecto o en caso de reportar algún efecto secundario. Los datos obtenidos como parte de este programa podrían ser utilizados en publicaciones o presentaciones médicas. Su nombre y otra información personal serán eliminados antes de usar los datos.
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Teléfonos de contacto de los investigadores
          </p>
          <p className="rtPar">
            El investigador responsable del proyecto es el{" "}
            <span style={{ fontFamily: "Helvetica-Bold", fontWeight: "bold" }}>
              Dr. Guillermo de Jesús García Félix
            </span>
            investigador principal de Exeltis Pharma México, quien proporcionará la información actualizada que se obtenga de esta investigación y garantizará la confidencialidad de esta información. Si tiene alguna duda sobre el proceso expresado en este escrito no dude exponerla hasta resolver todas sus interrogantes a través del teléfono +52 (55) 9185 2312
          </p>
          <p className="rtTitle" style={{ marginBottom: 5 }}>
            Datos de contacto del Comité de ética en Investigación
          </p>
          <span style={{ marginBottom: 5 }}>Nombre: Comité de Ética en Investigación Hospital La Misión, S. A. de C.V.</span><br />
          <span style={{ marginBottom: 5 }}>Dirección: Del Hospital No.112, 1° y 2° piso, Col. Sertoma. C.P. 64718, Monterrey, Nuevo León, México.</span><br />
          <span style={{ marginBottom: 5 }}>Presidente: Dr. José Francisco Islas Cisneros</span><br />
          <span style={{ marginBottom: 5 }}>Teléfono: 81 1492 4050 </span><br />
          <span style={{ marginBottom: 5 }}>Correo electrónico: investigacion@hospitallamision.com </span><br />
          <p className="rtMainTitle">
            DECLARACIÓN DE CONSENTIMIENTO DEL SUJETO
          </p>
          <p className="rtPar" style={{ marginBottom: 20 }}>
            He leído cuidadosamente este consentimiento informado, he hecho
            todas las preguntas pertinentes y todas me han sido respondidas
            satisfactoriamente. Para poder participar en el programa, marque con
            una{" "}
            <span style={{ fontFamily: "Helvetica-Bold", fontSize: 10 }}>
              X
            </span>{" "}
            si está de acuerdo con todos los siguientes puntos:
          </p>
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo en participar en el programa descrito anteriormente. Los objetivos y los posibles riesgos, inconvenientes y reacciones secundarias y adversas me han sido explicados a mi entera satisfacción. "
            }
          />
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo en responder a las preguntas que me realice mi médico prescriptor. Así mismo, mi información médica podrá ser utilizada con los mismos fines."
            }
          />
          <CreateCheckedTerm
            text={
              "Estoy de acuerdo, en caso de ser necesario, que se me contacte en el futuro si el proyecto requiere colectar información adicional o si encuentran información relevante para mi salud."
            }
          />
          <CreateCheckedTerm
            text={
              "Mi firma o huella también indica que he recibido un duplicado de este consentimiento informado."
            }
          />
        </div>
      </div>
      <div className="rtPage">
        <div className="rtContainer">
          <p className="rtMainTitle">Declaración del paciente</p>
          <p className="rtPar">
            Yo,{" "}
            <span className="rtBold" style={{ textDecoration: "underline" }}>
              {ciData.patientCiName}
            </span>{" "}
            declaro que es mi decisión participar en el programa. Mi participación es voluntaria.  He sido informado que puedo negarme a participar o terminar mi participación en cualquier momento del programa sin que sufra penalidad alguna o pérdida de beneficios. Si suspendo mi participación, recibiré el tratamiento médico habitual al que tengo derecho, no sufriré perjuicio en mi atención médica o en futuros programas de investigación. Yo puedo solicitar información adicional acerca de los riesgos o beneficios potenciales derivados de mi participación en el programa. Si tengo preguntas sobre el programa, puede ponerme en contacto en cualquier momento con el Dr. Guillermo de Jesús García Félix que está en el área de Traumatología y Ortopedia de Exeltis Pharma México al Teléfono +52 (55) 9185 2312. Debo informar a los investigadores de cualquier cambio en mi estado de salud o en la ciudad donde resido, tan pronto como sea posible. He leído y entendido toda la información que me han dado sobre mi participación en el programa. He tenido la oportunidad para discutirlo y hacer preguntas. Todas las preguntas han sido respondidas a mi satisfacción. He entendido que recibiré una copia firmada de este consentimiento informado.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.patientCiName}
              desc={"Nombre del participante o su Representante Legal"}
            />
            <CreateParticipant
              data={ciData.patientCiName}
              desc={"Firma o huella del participante o su Representante Legal"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.doctorFullName}
              desc={"Nombre del Médico prescriptor"}
            />
            <CreateParticipant
              data={ciData.doctorFullName}
              desc={"Firma del Médico prescriptor"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.firstWitnessName}
              desc={"Nombre del Testigo 1"}
            />
            <CreateParticipant
              data={ciData.firstWitnessName}
              desc={"Firma o huella del Testigo 1"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </div>
          <p className="rtPar" style={{ fontSize: 12 }}>
            Relación con el participante:{" "}
            <span>{ciData.firstWitnessRelationship}</span>
          </p>
          <p className="rtPar" style={{ fontSize: 12 }}>
            Dirección:{"  "}
            <span>{ciData.firstWitnessAddress}</span>
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <CreateParticipant
              data={ciData.secondWitnessName}
              desc={"Nombre del Testigo 2"}
            />
            <CreateParticipant
              data={ciData.secondWitnessName}
              desc={"Firma o huella del Testigo 2"}
              isSign={true}
            />
            <CreateParticipant
              data={getFormattedDate(new Date(ciData.consentDate))}
              desc={"Fecha"}
            />
          </div>
          <p className="rtPar" style={{ fontSize: 12 }}>
            Relación con el participante:{" "}
            <span>{ciData.secondtWitnessRelationship}</span>
          </p>
          <p className="rtPar" style={{ fontSize: 12 }}>
            Dirección:{"  "}
            <span>{ciData.secondWitnessAddress}</span>
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "center",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <div style={{ height: 200, width: 200 }}>
              <img
                style={{ maxHeight: 200, maxWidth: 200 }}
                src={PrincipalSign}
                alt="checked"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsentmentTemplate;
